export const MONTO_TOTAL = 'MONTO'
export const GALONES = 'GALON'
